import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCrew$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCrew extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b1a4ff5f8f2bccd588477f988e65de0f1c4fcee9', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'cfffdf86eeef26893e0e6ae776357c7d619f454c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3d7343d290b47ec56c30fa39d5c4b866322ebb14', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.842 6.257c.358.476.498 1.097.382 1.695l-.32 2.338c-.071 1.06-.932 1.863-1.93 1.798-.996.065-1.857-.737-1.928-1.798L8.78 7.952c-.088-.618.1-1.245.507-1.695.463-.513 1.11-.757 1.778-.757.67 0 1.317.24 1.778.757m-.073 6.656a.42.42 0 0 1 .453 0c1.072.537 1.763 1.686 1.778 2.955v.152c0 .264-.199.477-.444.477H7.444c-.245 0-.444-.213-.444-.477v-.152c.039-1.292.77-2.443 1.876-2.955a.44.44 0 0 1 .453 0 2.99 2.99 0 0 0 3.44 0m5.326-4.797c.315.39.439.9.336 1.39l-.281 1.919a1.6 1.6 0 0 1-1.698 1.475 1.6 1.6 0 0 1-1.698-1.475l-.235-1.919a1.64 1.64 0 0 1 .446-1.39 2.05 2.05 0 0 1 1.565-.621c.588-.03 1.16.197 1.565.621m-2.375 6.19a4.4 4.4 0 0 1 .367 1.803.39.39 0 0 0 .392.388h3.13a.39.39 0 0 0 .391-.389v-.124a2.7 2.7 0 0 0-1.604-2.376.4.4 0 0 0-.4 0c-.446.295-.973.45-1.51.442q-.263 0-.524-.046c-.242-.047-.344.093-.242.303m-12.151-4.8c-.103-.49.02-1 .336-1.39.406-.424.977-.65 1.565-.621a2.05 2.05 0 0 1 1.565.621c.359.37.524.883.446 1.39l-.235 1.919A1.6 1.6 0 0 1 5.548 12.9a1.6 1.6 0 0 1-1.698-1.475zm2.344 6.602a4.4 4.4 0 0 1 .367-1.801c.102-.21 0-.35-.242-.303a3 3 0 0 1-.525.046 2.67 2.67 0 0 1-1.51-.443.4.4 0 0 0-.399 0A2.7 2.7 0 0 0 2 15.985v.124a.39.39 0 0 0 .391.389h3.13a.39.39 0 0 0 .392-.389", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-crew", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-crew"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-crew":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCrew$1);
            }
            break;
    } });
}

const CosmosIconCrew = CosmosIconCrew$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCrew, defineCustomElement };
